import React from 'react';
import styled from 'styled-components';

import { BracketContainer, InfoAreaContainer as InfoAreaContainerBase } from './styled-components';
import TileWidget from './TileWidget';

import ActionButtons from './ActionButtons';

interface Props {
  onCancelClick?: () => void;
}

const NoLMPEntered = ({ onCancelClick }: Props) => (
  <TileWidget>
    <InfoAreaContainer>
      <BracketContainer>
        <LMPTextContainer>
          <EDDAndGestionalAge>
            Estimated Due Date <br /> & Gestional Age
          </EDDAndGestionalAge>
          <LMPStatus>Not Logged</LMPStatus>
        </LMPTextContainer>
      </BracketContainer>

      <InfoAreaText>
        Your estimated due date and gestational age are based on your last menstrual period. Please
        update the <strong>Period Tracker</strong> so we can calculate your dates.
      </InfoAreaText>
    </InfoAreaContainer>

    <ActionButtons onCancelClick={onCancelClick} />
  </TileWidget>
);

const InfoAreaContainer = styled(InfoAreaContainerBase)`
  margin-top: 32px;
  padding: 21px; 26px; 16px; 26px;
`;

const InfoAreaText = styled.p`
  font-size: 13px;
  text-align: center;
  line-height: 16px;

  margin-top: 24px;
`;

const LMPTextContainer = styled.p`
  text-align: center;
  margin: auto 20px;
`;

const LMPStatus = styled.span`
  display: block;
  font-size: 24px;
  ${({ theme }) => theme.fonts.DomaineDisplay};
`;

const EDDAndGestionalAge = styled.span`
  font-size: 14px;
`;

export default NoLMPEntered;
